module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-impressum-redaktion-dd4284a7a43dba757bb0c58712c19ac8.svg";